const openHour 	= 9;
const closeHour = 19;
export let timer = {
	target: null,
	init: function(){
		let $timers = document.querySelectorAll(".js-timerContent");
		$timers.forEach( ($t, index) => {
			console.log($t, index);
			timer.check($t);
		});
	},
	check: function( $dom ){
		let timerContent 		= $dom.querySelector(".js-timer_open");
		let timerContent_off 	= $dom.querySelector(".js-timer_close");
		let now = new Date();
		let hour = now.getHours();
		if( hour >= openHour && hour <= closeHour ){
			//営業時間中
			
			$dom.classList.remove("is-close");
			$dom.classList.add("is-open");
			console.log("is open");
			
			/*
			$dom.classList.remove("is-open");
			$dom.classList.add("is-close");
			console.log("is close");
			*/
		}else{
			//閉店中
			$dom.classList.remove("is-open");
			$dom.classList.add("is-close");
			console.log("is close");
		}
		
	}
}